import qs from 'querystring-browser'

import Storage from '@octadesk-tech/storage'

import router from '@/router'
import store from '@/store'

const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent'

const messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message'

const WIDGET_VERSION = 'octa-widget-v2'

export const getExternalSessionKey = key => {
  const { company } = store.getters
  if (company) {
    return `octa_chat_${company}_${key}`
  }
  return ''
}

const EVENTS = {
  externalSessionRestore: async event => {
    const restoredData = event.data.data

    if (restoredData && restoredData instanceof Object) {
      if (restoredData[getExternalSessionKey('fluxId')]) {
        const fluxId = restoredData[getExternalSessionKey('fluxId')]

        await store.dispatch('getFlux', fluxId)
      }

      if (restoredData[getExternalSessionKey('guestUser')]) {
        const guestUser = JSON.parse(
          restoredData[getExternalSessionKey('guestUser')]
        )

        await store.dispatch('upsertUser', guestUser)
      }
    }

    const { user, chat, flux } = store.getters

    if (user && chat && flux) {
      await store.dispatch('goToConversation')

      await store.dispatch('stopRestoring')
    }
  },
  toggle() {
    store.dispatch('toggleApp')
  },
  login(event) {
    store.dispatch('externalLogin', event.data.data)
  },
  setCustomFields(event) {
    store.dispatch('overrideSetCustomFields', event.data.data)

    store.dispatch('updateChatCustomFields')
  },
  setOrganization(event) {
    store.dispatch('setOrganization', event.data.data)

    store.dispatch('updateChatOrganization')
  },
  show() {
    store.dispatch('activeApp')

    store.dispatch('hideApp', false)
  },
  showButton() {
    store.dispatch('setButtonVisible', true)

    store.dispatch('hideApp', false)
  },
  hideButton() {
    store.dispatch('setButtonVisible', false)
  },
  toggleButton() {
    store.dispatch('toggleButton')
  },
  hide() {
    store.dispatch('inactiveApp')

    store.dispatch('hideApp', true)
  },
  clearSession() {
    store.dispatch('clearSession')
  },
  scrollPercent(event) {
    store.dispatch('setScrollPercent', event.data.data)
  },
  parentSize(event) {
    store.dispatch('setParentSize', event.data.size)
  },
  clearStorage() {
    Storage.clear()
  },
  closeConversation() {
    store.dispatch('closeConversation')
  },
  updateQueryOptions(event) {
    store.dispatch('setQueryOptions', {
      ...store.getters.options,
      ...event.data.data
    })
  }
}

window.mockSetCustomFields = EVENTS.setCustomFields

window.addEventListener('octaChatLogin', event =>
  EVENTS.login({ data: { data: event.detail } })
)

window[eventMethod](
  messageEvent,
  event => {
    if (event.data.id === store.getters.embedId && EVENTS[event.data.name]) {
      EVENTS[event.data.name](event)
    }
  },
  false
)

window.onfocus = () => store.dispatch('setFocused')

window.onblur = () => store.dispatch('setBlurred')

const post = payload => {
  if (window.parent) {
    payload.id =
      store.getters.embedId || qs.parse(location.search.replace('?', '')).id
    payload.domain = payload.domain || 'octachat'
    window.parent.postMessage(payload || {}, '*')
  }
}

const resolveIframeClasses = () => {
  const classes = []

  classes.push(WIDGET_VERSION)

  if (store.getters.active) {
    classes.push('octachatAppOpen')

    if (router.currentRoute.name === 'login') {
      classes.push('octadesk-octachat-login')
    } else {
      classes.push(router.currentRoute.name)

      if (
        router.currentRoute.name === 'contact' &&
        store.getters.flux &&
        store.getters.flux.kb.enabled
      ) {
        classes.push('contact-kb')
      }
    }
  } else {
    if (store.getters.showStories) {
      classes.push('octachatAppOpen')

      classes.push('octadesk-octachat-login')
    } else {
      classes.push('octachatAppClose')

      if (store.getters.showProactiveMsg) {
        const msgClass = store.getters.hasProactiveMsgSender
          ? 'octachatProactiveMsg'
          : 'octachatProactiveMsg--senderless'

        classes.push(msgClass)
      }
    }
  }

  if (store.getters.settings) {
    classes.push(`octadesk-octachat-app--${store.getters.settings.position}`)
  }

  return classes
}

export const changeIframeStyles = style => {
  post({
    name: 'changeIframeStyles',
    octachat: {
      style
    }
  })
}

export const changeIFrameClasses = () => {
  post({
    name: 'changeIFrameClasses',
    octachat: {
      classes: resolveIframeClasses()
    }
  })
}

export const notifyAgentMessage = () => {
  post({
    octaChatAgentMessage: true
  })
}

export const emitAppSession = encryptedSession => {
  post({
    name: 'storeAppSession',
    octachat: {
      appSession: encryptedSession
    }
  })
}

const dispatchCustomEvent = (eventName, data) => {
  const event = new CustomEvent(eventName, { detail: data })

  window.dispatchEvent(event)
}

export const notifyIsReady = () => {
  dispatchCustomEvent('onOctaChatReady')

  post({
    name: 'onChatReady',
    octachat: {
      isReady: true
    }
  })
}

export const postMessage = post
